
import Rater from 'vux/src/components/rater/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';

export default {

data(){
return {
maxValue:'',
evaluationDmDisabled:false,
serviceGrade:'',
serviceGrade2:'',
person2Show:false,
msgForm:{
evaluationNote:'',
evaluationDm:0,
serviceHospital:'',
serviceItem:'',
servicePerson:'',
serviceDate:'',
servicePerson2:'',
evaluationDm2:0,
evaluationNote2:''
},
}
},
components: {
Rater,Radio, Group, Cell,XTextarea,XButton, PopupRadio
},
methods:{
getGrape(num){
this.$nextTick(function(){
if(this.msgForm['evaluationDm'+num] == 5){
this['serviceGrade'+num] = '非常满意';

}else if(this.msgForm['evaluationDm'+num] == 4){
this['serviceGrade'+num] = '满意';

}else if(this.msgForm['evaluationDm'+num] == 3){
this['serviceGrade'+num] = '一般';

}else if(this.msgForm['evaluationDm'+num] == 2){
this['serviceGrade'+num] = '不满意';

}else if(this.msgForm['evaluationDm'+num] == 1){
this['serviceGrade'+num] = '非常不满意';

}else if(this.msgForm['evaluationDm'+num] == 0){
this.msgForm['evaluationDm'+num] = 1;
this['serviceGrade'+num] = '非常不满意';

}
})
},
msgSubmit(){
this.evaluationDmDisabled = true;
this.postDadta = {};
this.postDadta = new URLSearchParams();
this.postDadta.append('evaluationNote',this.msgForm.evaluationNote)
this.postDadta.append('evaluationDm',this.msgForm.evaluationDm)
this.postDadta.append('id',this.msgForm.id)
this.postDadta.append('serviceHospital',this.serviceHospital)
this.postDadta.append('serviceItem',this.serviceItem)
this.postDadta.append('servicePerson',this.servicePerson)
this.postDadta.append('serviceDate',this.serviceDate)
if(this.person2Show){
this.postDadta.append('servicePerson2',this.msgForm.servicePerson2)
this.postDadta.append('evaluationNote2',this.msgForm.evaluationNote2)
this.postDadta.append('evaluationDm2',this.msgForm.evaluationDm2)
}

var  _this = this;
fetch('post',urlConfig.serviceValuationSubmit,this.postDadta).then(function(response){
promptMessage('提示','提交成功');
_this.$router.push('/serviceSubmissionResult');

}).catch(function(error){
promptMessage('提示','提交失败,请重新提交！');
_this.evaluationDmDisabled = false;
})
},//提交
getData(){
this.id = this.$route.query.id;
var  _this = this;
fetch('get',urlConfig.serviceValuationList + '?id='+this.id).then(function(response){
/*     console.log(response,2)*/
_this.msgForm = response;
console.log(response,_this.msgForm)
var evaluationDmStr = response.evaluationDm;
_this.serviceHospital = response.serviceHospital;
_this.serviceItem = response.serviceItem;
_this.servicePerson = response.servicePerson;
_this.serviceDate = response.serviceDate;
console.log(evaluationDmStr,4)
if(evaluationDmStr !== null){
_this.evaluationDmDisabled = true;


}else {
_this.msgForm.evaluationDm = 5; 

}
_this.getGrape('');
if(response.servicePerson2 != null){  //如果存在第二个服务人员
_this.person2Show = true;
if(_this.msgForm.evaluationDm2 !== null){

}else {
_this.msgForm.evaluationDm2 = 5; 
}
_this.getGrape(2);
}else {
_this.person2Show = false;
}

}).catch(function(error){

})
}//获取数据
},
mounted(){
getken(this.getData);
}
}



// WEBPACK FOOTER //
// ./src/project/ValuationProject/serviceValuation.vue